import { TraitSale } from "types";
import * as traitSalesApi from "api/traitSalesApi";
import useFetchPromise from "hooks/useFetchPromise";

const useFetchTraitSales = (address?: string) =>
  useFetchPromise<TraitSale[], string | undefined>(
    traitSalesApi.fetchTraitSales,
    address
  );

export default useFetchTraitSales;
